import React from 'react';
import { Col, Button } from 'antd';
import { FaTrash } from 'react-icons/fa';

import { MealContext } from './MealDetails';
import { AdminDeleteModal } from '../../meals/components/DeleteMeal';
import { GlobalModalHandler } from '../../layout/GlobalModal';

export const ActionButtons: React.FC = () => {
  const { onPressDelete, handleFieldChange } = React.useContext(MealContext);

  const deleteMeal = () => {
    const content = (
      <AdminDeleteModal
        onPressDelete={onPressDelete}
        handleFieldChange={handleFieldChange}
      />
    );
    GlobalModalHandler({ content });
  };

  return (
    <Col className="action-buttons-container">
      <div className="action-button-wrapper">
        <Button type="link" onClick={deleteMeal}>
          <FaTrash size={16} color="#8dc63f" />
        </Button>
      </div>
    </Col>
  );
};
